module.exports = __webpack_public_path__ + "img/gvoz2.0a9d1b92.svg";